import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';

import { AuthenticationService } from './authentication/authentication.service';
import { FetchNotifications } from './notifications/notifications.actions';
import { ActionsOnStartup } from './users/user.actions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();
    private pollInterval: any;
    title = 'resume-app-frontend';
    redirecting: boolean;

    constructor(private store: Store, private logger: NGXLogger, private authenticationService: AuthenticationService) {}

    ngOnInit(): void {
        if (!this.authenticationService.getToken()) return;

        this.store.dispatch(new ActionsOnStartup());
        this.startPolling();

        // Pause polling when tab is hidden, resume when visible
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                this.stopPolling();
            } else if (this.authenticationService.isUserLoggedIn()) {
                this.store.dispatch(new FetchNotifications());
                this.startPolling();
            }
        });
    }

    ngOnDestroy(): void {
        this.stopPolling();
        this.subscriptions.unsubscribe();
    }

    private startPolling(): void {
        this.stopPolling();
        this.pollInterval = setInterval(() => {
            if (this.authenticationService.isUserLoggedIn()) {
                this.store.dispatch(new FetchNotifications());
            }
        }, 60000);
    }

    private stopPolling(): void {
        if (this.pollInterval) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
    }
}
